import { http } from 'core/utils/httpClient';
import type { PaginatedList } from './dtoModels/paginatedList';
import type { Paginator } from './dtoModels/paginator';
import type { GetTagsRequest } from './dtoModels/tags/getTagsRequest';
import type { TagResponse } from './dtoModels/tags/tagResponse';
import type { Tag } from 'models/tag';

const mapTag = (source: TagResponse): Tag => ({
  ...source,
});

const mapTags = (source: TagResponse[]): Tag[] => source.map(mapTag);

export async function getTagsAsync(
  request: GetTagsRequest & Paginator
): Promise<PaginatedList<Tag>> {
  const { data } = await http.get<PaginatedList<TagResponse>>('tags', {
    params: request,
  });

  return { ...data, items: mapTags(data.items) };
}

export async function getTagAsync(id: number): Promise<Tag> {
  const { data } = await http.get<TagResponse>(`tags/${id}`);
  return mapTag(data);
}

export async function createTagAsync(name: string): Promise<Tag> {
  const { data } = await http.post<TagResponse>('tags', {
    name,
  });
  return mapTag(data);
}

export async function updateTagAsync(id: number, name: string): Promise<Tag> {
  const { data } = await http.put<TagResponse>(`tags/${id}`, {
    name,
  });
  return mapTag(data);
}

export async function deleteTagAsync(id: number): Promise<void> {
  await http.delete(`tags/${id}`);
}
